import { render, staticRenderFns } from "./ConversationHeader.vue?vue&type=template&id=13c690a6&scoped=true"
import script from "./ConversationHeader.vue?vue&type=script&lang=ts"
export * from "./ConversationHeader.vue?vue&type=script&lang=ts"
import style0 from "./ConversationHeader.vue?vue&type=style&index=0&id=13c690a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c690a6",
  null
  
)

export default component.exports